import {Outlet, useParams} from "react-router-dom";
import cnrlLogo from '@images/company_logos/cnrl.png';
import watchdog from '@images/company_logos/theWatchdog.png';
import whitecapLogo from '@images/company_logos/whitecap.png';
import exxonmobilLogo from '@images/company_logos/exxonmobil.png';
import aeraLogo from '@images/company_logos/aera.png';
import apache from '@images/company_logos/apache.png';
import crc from '@images/company_logos/crc-logo.png';
import {useState} from "react";

export default function Company() {
    let params = useParams();
    const [company] = useState(getCompany(params.companyId));
    return (<div>
            {company && <Outlet context={[company]}/>}
        </div>
    );
}

const companies = {
    ExxonMobil: {
        id: '324',
        name: 'EXXONMOBIL'
    },
    Cnrl: {
        id: '48',
        name: 'CNRL'
    },
    Whitecap: {
        id: '97',
        name: 'WHITECAP'
    },
    Aera: {
        id: '312',
        name: 'AERA'
    },
    Afti: {
        id: '2',
        name: 'AFTI'
    },
    Apache: {
        id: '390',
        name: 'APACHE'
    },
    Crc: {
        id: '315',
        name: 'CRC'
    }
}

const identityProviders = {
    k9Test: "K9 Test Identity",
    pingIdentity: "Ping Identity",
    microsoft: 'Microsoft',
    okta: "Okta"
}

const getCompanySsoSignInAddress = (companyName) => {
    return `${process.env.REACT_APP_K9_API_ADDRESS}/sso/${companyName.toLowerCase()}/saml2/signin`;
}

const getCompany = (companyId) => {
    switch (companyId) {
        case "2":
            return {
                name: "AFTI",
                identityProvider: identityProviders.microsoft,
                logo: watchdog,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Afti.name);
                }
            }
        case companies.Cnrl.id:
            return {
                name: companies.Cnrl.name,
                identityProvider: identityProviders.pingIdentity,
                logo: cnrlLogo,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Cnrl.name);
                }
            }
        case companies.ExxonMobil.id:
            return {
                name: companies.ExxonMobil.name,
                identityProvider: identityProviders.microsoft,
                logo: exxonmobilLogo,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.ExxonMobil.name);
                }
            }
        case companies.Whitecap.id:
            return {
                name: companies.Whitecap.name,
                identityProvider: identityProviders.microsoft,
                logo: whitecapLogo,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Whitecap.name);
                }
            }
        case companies.Aera.id:
            return {
                name: companies.Aera.name,
                identityProviders: identityProviders.microsoft,
                logo: aeraLogo,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Aera.name);
                }
            }
        case companies.Apache.id:
            return {
                name: companies.Apache.name,
                identityProvider: identityProviders.microsoft,
                logo: apache,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Apache.name);
                }
            }
        case companies.Crc.id:
            return {
                name: companies.Crc.name,
                identityProvider: identityProviders.microsoft,
                logo: crc,
                signInHandler: () => {
                    window.location = getCompanySsoSignInAddress(companies.Crc.name);
                }
            }
        default:
            return {}
    }
}


